import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  SiMui,
  SiAntdesign,
  SiRedux,
  SiChakraui,
  SiBootstrap,
  SiTailwindcss,
  SiFirebase,
  SiVite,
  SiJavascript,
} from "react-icons/si";
import { DiReact } from "react-icons/di";

const libraries = [
  { icon: <SiMui />, name: "Material UI" },
  { icon: <SiAntdesign />, name: "Ant Design" },
  { icon: <SiChakraui />, name: "Chakra UI" },

  { icon: <SiRedux />, name: "Redux" },
  { icon: <SiBootstrap />, name: "React Bootstrap" },
  {
    icon: (
      <svg
        width="70"
        height="70"
        viewBox="0 0 223 250"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M162.934 23.9015L111.221 53.5851L59.5067 23.9015L111.221 0L162.934 23.9015Z"
            fill="white"
          />
          <path
            d="M172.405 29.4741L223 58.8421V112.728L172.405 82.5072V29.4741Z"
            fill="white"
          />
          <path
            d="M59.5068 38.2387V93.4553L111.221 123.138V67.9248L59.5068 38.2387Z"
            fill="white"
          />
          <path
            d="M162.934 93.4553V38.2387L111.221 67.9248V123.138L162.934 93.4553Z"
            fill="white"
          />
          <path
            d="M50.0352 29.4741V82.5072L0 112.728V58.8421L50.0352 29.4741Z"
            fill="white"
          />
          <path
            d="M162.934 108.579V163.795L111.221 193.479V138.262L162.934 108.579Z"
            fill="white"
          />
          <path
            d="M223 125.203V179.09L172.405 208.457V154.571L223 125.203Z"
            fill="white"
          />
          <path
            d="M59.5068 154.571V208.457L0 179.09V125.203L59.5068 154.571Z"
            fill="white"
          />
          <path
            d="M111.221 207.815L162.934 237.498L111.221 250L59.5068 237.498L111.221 207.815Z"
            fill="white"
          />
          <path
            d="M111.221 138.262V193.479L59.5068 163.795V108.579L111.221 138.262Z"
            fill="white"
          />
        </g>
      </svg>
    ),
    name: "Formik",
  },
];

function LibrariesTools() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {libraries.map(({ icon, name }, idx) => (
        <Col xs={4} md={2} className="tech-icons" key={idx}>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-${name}`}>{name}</Tooltip>}
          >
            <span>{icon}</span>
          </OverlayTrigger>
        </Col>
      ))}
    </Row>
  );
}

export default LibrariesTools;
